import XLSX from "xlsx";

/**
 * 导出表格到 Excel（默认所有列为原格式字符串，指定列转为数值）
 * @param {string} tableId - 表格 DOM 的 id
 * @param {Array} numberLabels - 需要转为数值的列 ["金额"]
 * @param {string} filename - 导出的文件名
 */
export function exportTableToExcel(
  tableId,
  numberLabels = [],
  filename = "导出表.xlsx",
  isAllNumber = false
) {
  let table = document.querySelector("#" + tableId);
  if (!table) {
    console.error("表格未找到:", tableId);
    return;
  }

  let clone = table.cloneNode(true);
  // 删除所有 popover 内容
  clone.querySelectorAll(".el-popover").forEach((el) => el.remove());

  // 转成 worksheet
  let worksheet = XLSX.utils.table_to_sheet(clone, { raw: true });

  // 获取表头（第一行数据），对应 el-table-column 的 label
  let range = XLSX.utils.decode_range(worksheet["!ref"]);
  let headers = [];
  for (let C = range.s.c; C <= range.e.c; ++C) {
    let addr = XLSX.utils.encode_cell({ r: 0, c: C });
    headers.push(worksheet[addr]?.v || "");
  }

  // 遍历 worksheet 的每个单元格
  Object.keys(worksheet).forEach((cellAddr) => {
    if (cellAddr[0] === "!") return; // 跳过元数据
    let { r, c } = XLSX.utils.decode_cell(cellAddr);
    if (r === 0) return; // 跳过表头

    let label = headers[c];
    let cell = worksheet[cellAddr];

    if (isAllNumber || numberLabels.indexOf(label) != -1) {
      // 转数值
      let num = Number(cell.v);
      if (!isNaN(num)) {
        cell.t = "n";
        cell.v = num;
      }
    } else {
      // 默认转字符串，避免科学计数法
      cell.t = "s";
      cell.v = String(cell.v);
    }
  });

  // 导出 workbook
  let wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, worksheet, "Sheet1");
  XLSX.writeFile(wb, filename);
}
